import type { GridProps as MantineGridProps } from '@mantine/core';
import { Grid as MantineGrid } from '@mantine/core';

type GridProps = MantineGridProps;

export const Grid = (props: GridProps) => {
  return <MantineGrid {...props} />;
};

Grid.Col = MantineGrid.Col;
